import React from 'react';
import Select from 'react-select';
import { Controller } from 'react-hook-form';

const InputSelectSearch = ({
  label,
  name,
  control,
  options,
  error,
  onClick,
  required = true,
  placeholder = 'Ketik untuk mencari...',
  onInputChange,
  isLoading = false
}) => {
  return (
    <div className="flex flex-col w-full" onClick={() => onClick()}>
      <label className="text-black text-left mb-1">
        {label}{required && <span className="text-red-500"> *</span>}
      </label>

      <Controller
        name={name}
        control={control}
        rules={{ required }}
        render={({ field }) => (
          <Select
            {...field}
            options={options}
            placeholder={placeholder}
            className="w-full"
            classNamePrefix="react-select"

            /* 🔥 INI PENTING */
            isLoading={isLoading}
            onInputChange={(inputValue, actionMeta) => {
              if (actionMeta.action === 'input-change') {
                onInputChange && onInputChange(inputValue);
              }
            }}

            value={
              options.find(option => option.value === field.value) || null
            }
            onChange={(selectedOption) =>
              field.onChange(selectedOption?.value)
            }
            isClearable
            noOptionsMessage={() => 'Ketik minimal 3 huruf'}
          />
        )}
      />

      {error && (
        <span className="text-red-500 text-sm text-left mt-1">
          {label} harus diisi
        </span>
      )}
    </div>
  );
};

export default InputSelectSearch;
